// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1-ZDs","content":"LoadingAlert_content__30rZY"};